import { render } from "./CampaignGoal.vue?vue&type=template&id=6c7bbd9d"
import script from "./CampaignGoal.vue?vue&type=script&lang=js"
export * from "./CampaignGoal.vue?vue&type=script&lang=js"
script.render = render

export default script